import request, { IWorkspaceResponse } from '/@/api/http/request'

export interface fightPlanParam {
    task_type: string
    job_name: string
    review_status: string
    start_time: string
    end_time: string
}

export interface fightPlanPageRequest {
    page: number
    page_size: number
    param: fightPlanParam
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const getFightPlanPage = async function (body: fightPlanPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/plan/page'
  const result = await request.post(url, body)
  return result.data
}

// 保存计划任务审核
export const saveTaskReview = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/plan/save'
  const result = await request.post(url, body)
  return result.data
}

// 审核计划任务
export const reviewScheduledTasks = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/plan/review'
  const result = await request.post(url, body)
  return result.data
}

// 删除计划任务
export const deleteScheduledTasks = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/plan/delete/${id}`
  const result = await request.delete(url)
  return result.data
}

// 取消计划任务
export const cancelScheduledTasks = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/plan/revoke/${id}`
  const result = await request.get(url)
  return result.data
}

// 查询计划任务审核详情
export const getScheduledTasks = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/wayline/api/v1/plan/detail/${id}`
  const result = await request.get(url)
  return result.data
}

// 最近七天任务
export const getRecentlyTasks = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/jobs/recently'
  const result = await request.post(url, body)
  return result.data
}

// 绑定航线
export const getBindWaylines = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/bind/wayline'
  const result = await request.post(url, body)
  return result.data
}

// 获取航线文件分页列表-审核角色用
export const getReviewWaylinesPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/wayline-by-reviews/page'
  const result = await request.post(url, body)
  return result.data
}
